import Skeleton from './Skeleton';

/**
 * A wrapper component that conditionally renders a skeleton or its children based on loading state
 * @param {Object} props
 * @param {boolean} props.loading - Whether to show the skeleton or the children
 * @param {string} [props.className] - CSS class to apply to the skeleton
 * @param {React.ReactNode} props.children - The content to show when not loading
 * @returns {JSX.Element} Either a Skeleton component or the children
 */
const SkeletonWrapper = ({ loading, className, children }) =>
    loading ? <Skeleton className={className} /> : children;

export default SkeletonWrapper;
